// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { getPlaceholder } from 'utils/assetsUtils';
import { handleTagEvent } from 'utils/tagManagerUtils';

import BackgroundImage from 'containers/fragments/BackgroundImageContainer';

export type StateProps = {
  placeholder: string,
};

type Props = {
  link: string,
  name: string,
  description?: string,
  img?: string,
  clubName?: string,
} & StateProps;

const CardTeam = ({ link, img = '', name, description, clubName, placeholder }: Props) => (
  <div className="col col-md-4">
    <Link
      to={link}
      onClick={handleTagEvent(`card_${name}`, `clic_${link}`, clubName)}
      className="box card card--content card--wide mb-2 mb-lg-4"
      title="Voir l'équipe"
    >
      <BackgroundImage
        className="card__thumbnail img-blue"
        illustration={img}
        baliseImg />
      <div className="card__body">
        <h3 className="card__title">{name}</h3>
        <p className="card__desc">{description}</p>
      </div>
      <div className="card__footer" style={{backgroundColor:'#fff'}}>
        <span className="link-chevron ">
          Voir l&apos;équipe
          <i className="icon icon-chevron-right"/>
        </span>
      </div>
    </Link>
  </div>
);

CardTeam.defaultProps = {
  img: getPlaceholder(),
};

export default CardTeam;
